import React from 'react'; 

const hardCodedAdminUsers = [
    'd51717c8-73ca-4b10-a9a5-608e665cf60b',
    '3ef484b2-f174-4820-bfe0-e49ae54740bd',
    '02bc22ed-fc8f-4e21-96c6-35d010e17fd0',
    '6e7d663b-af9d-494c-bcdd-1fb86c37fb24',
    'b030be61-26f1-4eb7-85db-af11845bf0c6', // Hoya Todd's Azure account deforestt@hoya.com 
    '521eab31-19b3-444e-ab62-6dfb02e6ccde', // Hoya Kristen's Azure account langleyk@hoya.com
    '745f5ed9-785a-496d-9a9e-8ac403ab4965', // Hoya LMS Administrator GP-Strategies account gp-strategies@hoya.com, gpstrategies@hoya.com
    '3c63faac-4558-4797-acc4-9a336bdb6cc2', // Hoya Gary's prod user
    '289553b6-0750-4c0a-8ee0-d6b2e2792075', // Flavia Bittencourt (email: flavia.buittencourt@hoya.com and AzureAD/O365 authentication: bittencourt@hoya.com) 
    '5a756c80-ed97-4166-a2fc-88492a78bf4e', // Nayara Couto (email: nayara.couto@hoya.com and AzureAD/O365 authentication: couton@hoya.com)
    '549d1771-d849-430f-8b54-10cac8ec6ba9', // Daniele Freire (email: daniel.freire@hoya.com and AzureAD/O365 authentication: freired@hoya.com)
    'd0c15883-0f9e-4a76-85f9-7b022314fa0b', // Sandro Britto (email: sandro.britto@hoya.com and AzureAD/O365 authentication: britto@hoya.com)
    '3d3f134e-5710-46f6-8d65-8949975ce306', // Julia Chies (email: juliana.chies@hoya.com and AzureAD/O365 authentication: chies@hoya.com)
    '012eea88-a5ad-487a-b83e-15bbdd3021a8', // Reginaldo Marques (email: reginaldo.marques@hoya.com and AzureAD/O365 authentication: marquesr@hoya.com) 
];
 
// BIW's own company id per environment. A token whose company — or whose
// impersonation actor (act/actor claim) — is one of these belongs to a BIW
// employee masquerading into a client company, as opposed to an external client.
const BIW_COMPANY_IDS = [
    '2eddede7-12e0-493a-ba36-3940b96b1cac', // QA / localhost
    '4475f9be-8904-46a9-8e5f-2af37f1f2ead', // PPRD
    'c0949994-08a7-45ab-866b-83bf3e5bb0eb', // PROD
];

class AuthService {
    _auth = null;
    context = React.createContext( {} );

    constructor( auth = undefined ) {
        this._auth = auth;
    }

    events = {
        signIn: {
            on: ( callback ) => this._auth.events.signIn.on( callback ),
        },
        signOut: {
            on: ( callback ) => this._auth.events.signOut.on( callback ),
        },
        stateChange: {
            on: ( callback ) => this._auth.events.stateChange.on( callback ),
        },
    };

    setAuthController( authController ) {
        this._auth = authController;
    }

    getAccessToken() {
        return this._auth?.state?.access_token;
    }

    getCompanyId() {
        return this._auth?.state?.claims?.company_id;
    }

    /**
     * True when the current token belongs to a BIW employee (the token's company,
     * or its impersonation actor's company, is a known BIW company id). External
     * clients never match. NOTE: this is a UX gate only — it must be backed by
     * server-side enforcement on any BIW-only data/operations.
     */
    isBiwEmployee() {
        const ids = [
            this.getCompanyId(),            // claims.company_id (cmp)
            this._auth?.state?.actor?.cmp,  // impersonation actor's company...
            this._auth?.state?.act?.cmp,    // ...under either claim name
        ];

        return ids.some( ( id ) => BIW_COMPANY_IDS.includes( id ) );
    }

    isAuthenticated() {
        return Boolean( this.getAccessToken() );
    }

    isHoya() {
        const companyId = this._auth?.state?.claims?.[ 'company_id' ];
        
        const hoyaCompanyIds = [ 
            'f079d7a1-7a56-46c7-ad2d-88134d1b4a5d',
            '5caf0024-0b69-419f-b233-b3797df18864',
            'd0cd644b-4691-412d-83d1-0fa0952a6050'
        ];

        return hoyaCompanyIds.includes( companyId );
    }

    isAdministrator() {
        const isAdmin = this._auth?.state?.claims?.attributes?.[ 'IS_ADMIN' ];
        const isCourseServiceAdmin = this._auth?.state?.claims?.permissions?.[ 'course-service' ];
        const companyId = this._auth?.state?.claims?.[ 'company_id' ];
        const personId = this._auth?.state?.claims?.[ 'person_id' ];
        
        if ( isAdmin 
            || isCourseServiceAdmin
            || ( companyId == 'd0cd644b-4691-412d-83d1-0fa0952a6050' && hardCodedAdminUsers.includes( personId ) ) ) { // hard coded bandaid solution bc IS_ADMIN doesnt stick to salesforce Hoya users in prod
            return true;
        } else {
            const host = window.location.hostname.toLocaleLowerCase();

            // QA and localhost
            if ( host === 'qa.courses.biw.cloud' || host === 'localhost' ) {
                const ids = [ this.getCompanyId(), this._auth?.state?.actor?.cmp, this._auth?.state?.act?.cmp ];
                
                // If includes the BIW company id
                if ( ids.includes( '2eddede7-12e0-493a-ba36-3940b96b1cac' ) ) {
                    return true;
                }
            }

            // PPRD
            if ( host === 'pprd.courses.biw.cloud'  ) {
                const ids = [ this.getCompanyId(), this._auth?.state?.actor?.cmp, this._auth?.state?.act?.cmp ];

                // If includes the BIW company id
                if ( ids.includes( '4475f9be-8904-46a9-8e5f-2af37f1f2ead' ) ) {
                    return true;
                }
            }
            
            // PROD
            if ( host === 'courses.biw.cloud'  ) {
                const ids = [ this.getCompanyId(), this._auth?.state?.actor?.cmp, this._auth?.state?.act?.cmp ];

                // If includes the BIW company id
                if ( ids.includes( 'c0949994-08a7-45ab-866b-83bf3e5bb0eb' ) ) {
                    return true;
                }
            }
        }

        return false;
    }

    hasPermission( key ) { 
        const permissions = this.getPermissions();
        if ( !permissions ) { return false; }
        return permissions.includes( key );
    }

    getPermissions() {
        if ( this.isAdministrator() ) {
            return [
                'create-asset',
                'list-assets',
                'read-asset',
                'delete-asset',
                'edit-asset',
                'list-assignments',
                'read-assignment',
                'edit-assignments',
                'delete-course',
                'create-course',
                'list-courses',
                'read-course',
                'edit-course',
                'create-curriculum',
                'list-course-tags',
                'delete-curriculum',
                'list-curriculums',
                'read-curriculum',
                'edit-curriculum',
                'list-curriculum-tags',
                'create-enrollment',
                'list-enrollments',
                'read-enrollment',
                'edit-enrollment',
                'create-learning-object',
                'delete-learning-object',
                'list-learning-objects',
                'read-learning-object',
                'edit-learning-object',
                'list-learning-object-tags',
                'list-segment-curriculums' 
            ];
        } else {
            return [];
        }
    }

    getClaims() {
        return this._auth?.state?.claims;
    }

    async signIn() {
        await this._auth.signIn();
    }

    async signOut() {
        await this._auth.signOut();
    }

    async renew() {
        await this._auth.renew();
    }
}

export const authService = new AuthService();